// src/components/PeoplePlan/TheBench/hooks/useWorkflowSorting.js
import { useState, useEffect } from 'react';

const useWorkflowSorting = (data) => {
  const [sortedData, setSortedData] = useState([]);
  const [sortColumn, setSortColumn] = useState("employee_name");
  const [sortOrder, setSortOrder] = useState("asc");

  // Initialize sorted data
  useEffect(() => {
    setSortedData(data);
  }, [data]);

  // Sorting handler
  const handleSort = (column) => {
    const newSortOrder = sortColumn === column && sortOrder === "asc" ? "desc" : "asc";
    setSortColumn(column);
    setSortOrder(newSortOrder);

    const sorted = [...data].sort((a, b) => {
      const valueA = a[column] ? a[column].toString().toLowerCase() : "";
      const valueB = b[column] ? b[column].toString().toLowerCase() : "";
      
      if (valueA < valueB) return newSortOrder === "asc" ? -1 : 1;
      if (valueA > valueB) return newSortOrder === "asc" ? 1 : -1;
      return 0;
    });

    setSortedData(sorted);
  };

  // Reset sort to default
  const resetSort = () => {
    setSortColumn("employee_name");
    setSortOrder("asc");
    
    const sorted = [...data].sort((a, b) =>
      a.employee_name.localeCompare(b.employee_name)
    );
    
    setSortedData(sorted);
  };

  return {
    sortedData,
    sortColumn,
    sortOrder,
    handleSort,
    resetSort
  };
};

export default useWorkflowSorting;